import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  GetAllSubscriptionSetDataByServID,
  GetSubscriptionSetData,
} from "../../../../../Api/ServiceDatas";
import {
  GetServiceSetData,
  GetServiceSetDataNoHide,
} from "../../../../../ApiTS/ServiceDatasTS";
import Flex from "../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface SunriseSubsProps {}

export default function SunriseSubs({}: SunriseSubsProps) {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );

  const sunsetSubsId = sunsetDetailData?.sunsetSubsId;
  const sunsetSubsData = GetSubscriptionSetData(sunsetSubsId)[0];
  const sunsetServData = GetServiceSetData(sunsetSubsData?.SVC_ID);

  const [newServList, setNewServList] = useState([
    // 신규 전환 서비스 리스트
    { value: "", label: "서비스 선택" },
  ]);
  const [newSubsList, setNewSubsList] = useState([
    // 신규 전환 subscription 리스트
    { value: "", label: "subscription 선택" },
  ]);

  const [sunriseServId, setSunriseServId] = useState<OptionType>({
    // 신규 전환 서비스
    value: location?.state ? `${location?.state?.sunsetData?.srisSubs}` : "",
    label: location?.state
      ? `${location?.state?.sunsetData?.srisSubs}_${getSubsNameBySubsId3(
          location?.state?.sunsetData?.srisSubs
        )}`
      : "서비스 선택",
  });
  const [sunriseSubsId, setSunriseSubsId] = useState<OptionType>({
    // 신규 전환 subscription
    value: location?.state ? `${location?.state?.sunsetData?.srisSubs}` : "",
    label: location?.state
      ? `${location?.state?.sunsetData?.srisSubs}_${getSubsNameBySubsId3(
          location?.state?.sunsetData?.srisSubs
        )}`
      : "subscription 선택",
  });

  useEffect(() => {
    if (sunriseSubsId?.value !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunriseSubsId: +sunriseSubsId?.value!,
      });
    }
  }, [sunriseSubsId]);

  useEffect(() => {
    if (sunsetSubsId !== 0) {
      const subsOptionList = [];

      const subsetSvcId = GetSubscriptionSetData(+sunsetSubsId ?? 0)[0]?.SVC_ID;

      const subsNameListByServiceId =
        GetAllSubscriptionSetDataByServID(subsetSvcId);
      console.log(subsNameListByServiceId);

      for (let i = 0; i < subsNameListByServiceId.length; i++) {
        const e = subsNameListByServiceId[i];
        const subsId = e?.SUBS_ID;
        const subsName = getSubsNameBySubsId3(subsId);

        subsOptionList.push({
          value: `${subsId}`,
          label: `${subsId}_${subsName}`,
        });
      }

      setNewSubsList(subsOptionList);
    }
  }, [sunsetSubsId]);

  useEffect(() => {
    // serv 선택 옵션
    const servOptionList = [];

    const activeServs = GetServiceSetDataNoHide();

    for (let i = 0; i < activeServs?.length; i++) {
      const e = activeServs[i];

      servOptionList.push({
        label: `${e?.SVC_ID}_${e?.SVC_NMKR_TEMP}`,
        value: `${e?.SVC_ID}`,
      });
    }

    setNewServList(servOptionList);
  }, []);

  useEffect(() => {
    // subscription 선택 옵션
    const subsBySvcId = GetAllSubscriptionSetDataByServID(
      Number(sunriseServId?.value)
    );
    const subsOptionList = [];

    for (let i = 0; i < subsBySvcId.length; i++) {
      const e = subsBySvcId[i];

      subsOptionList.push({
        label: `${e?.SUBS_ID}_${getSubsNameBySubsId3(e?.SUBS_ID)}`,
        value: `${e?.SUBS_ID}`,
      });
    }

    setNewSubsList(subsOptionList);
  }, [sunriseServId?.value]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>신규 전환 서비스</VerticalTableLabel>

      <Flex gapSize={10}>
        {/* 일출 대상 서비스 선택 */}
        {buttonType === "view" ? (
          <VerticalTableValue style={{ width: 120 }}>
            {sunriseSubsId?.label}
          </VerticalTableValue>
        ) : (
          <DropDown
            optionList={newServList}
            dropdownValue={sunriseServId}
            setDropDownValue={setSunriseServId}
            isDisabled={sunsetDetailData?.sunsetSubsId === 0}
            boxWidth={120}
          />
        )}

        {/* 일출 대상 subs 선택 */}
        {buttonType === "view" ? (
          <VerticalTableValue style={{ width: 180 }}>
            {sunriseSubsId?.label}
          </VerticalTableValue>
        ) : (
          <DropDown
            optionList={newSubsList}
            dropdownValue={sunriseSubsId}
            setDropDownValue={setSunriseSubsId}
            isDisabled={
              sunsetDetailData?.sunsetSubsId === 0 ||
              sunriseServId?.value === ""
            }
            boxWidth={180}
          />
        )}
      </Flex>
    </VerticalTableRow>
  );
}
